import React from 'react'
import { useNavigate } from 'react-router-dom'
import starslogo from '../Images/Starts.png'

const Success = () => {
    const navigate=useNavigate()
  return (
    <div className="referral-success-container">
  <div className="back-arrow" onClick={()=>navigate('/refer')}>←</div>

  <div className="referral-status">
    {/* <span className="success-icon">✅</span> */}
    <span className="success-text">✔️ Referral Successfull</span>
    <div className="referral-time">01 Apr 2025, 04:18 PM</div>
    <div className="referral-number">Ref No. 203232 4670</div>
  </div>

 <div className="referral-box"
 style={{
    backgroundImage: `url(${starslogo})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }}
 >
  <p>
    You will earn <strong>5 Points</strong> when your friend subscribes to
    <br />
    <strong>Bigcash Games</strong>
  </p>
  <a href="#" className="refer-another">Refer Another</a>
  {/* <img src={starslogo} alt="Stars" className="stars-image" /> */}
</div>


  <button className="referral-button" onClick={()=>navigate('/referal-points')}>My Referral Points</button>
</div>

  )
}

export default Success
